module.exports = __webpack_public_path__ + "img/selectedCompletion.d3b4343f.png";